<!--详情页面基础信息-->
<template>
    <div class="flex-col">
        <div v-for="(group,count) in dynamicData" :key="count">
            <form-group-view v-if="group.type === 'group'" :group-data="group"
                             @groupChildrenChange="groupDataChange(group,$event)"/>

            <form-select-view v-if="group.type === 'selectGroup'" :group-data="group"
                             @groupChildrenChange="groupDataChange(group,$event)"/>

             <form-group-view v-if="group.type === 'type-hidden'" :group-data="group"
                             @groupChildrenChange="groupDataChange(group,$event)"/>
         
                             
            <addTypeView v-if="group.type === 'type-add'"  :group-data="group" @addTypeChange="addTypeChangeData(group,$event)"></addTypeView>
        </div>

    </div>
</template>

<script>

    import FormGroupView from "../../formGroupView";
    import FormSelectView from "../../formSelectView";
    import addTypeView from "../../addTypeView";
    export default {
        name: 'dynamicView',
        components: {
            FormGroupView,
            FormSelectView,
            addTypeView
        },
        data() {
            return {
                // formData: [],
                restaurants: [],
                key: '',
                index: 0,
                stagingData:[],
                Release:[],
            };
        },
        mounted() {
            console.log('this.dynamicData=', this.dynamicData)

        },
        props: {
            disable: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            dynamicData: {
                type: Array,
                default() {
                    return [];
                }
            },
            businessId: {},
        },
        computed: {},
        watch: {},
        methods: {
            reload() {
                this.$forceUpdate()
            },
            getSaveData() {
                return this.dynamicData;
            },
            verifyDynamicData(moreDynamicData) {
                console.log('最后给后端的数据', this.dynamicData);
                console.log(moreDynamicData, '============》web端返回来的数据')
                for (const single of moreDynamicData) {
                    console.log(single, '分解出来的数据看看呢')
                    let {dynamicForm, eventName} = single

                    if (this.$verify.isEmptyArray(dynamicForm)) return true;
                    for (const group of dynamicForm) {
                        if (!this.verifyData(group, eventName)) {
                            return false;
                        }
                    }
                }


                console.log('动态表单数据校验通过！');
                return true;
            },
            toast(msg, flag = false) {
                let param = {event: 'toast', data: {msg, flag}};
                this.$root.$emit('jqBridge', param);
            },
            verifyData(data, fatherName = '') {
                let {label, value, children, required, regx, type} = data;
                let hintName = this.$verify.isEmpty(fatherName) ? `[${label}]` : `${fatherName}-[${label}]`;
                if (type === 'hidden') return true;
                console.log(hintName, '-value=', value)
                // 先检查自身-暂时不为group的都需要检查自身
                if (type !== 'group') {
                    if (required && this.$verify.isEmpty(value)) {
                        this.toast(`${hintName}数据为空！`);
                        return false;
                    }
                    if (!this.$verify.isEmpty(value) && !this.$verify.isEmpty(regx)) {
                        let exp = this.$dynamicTool.util.getRealReg(regx);
                        if (!(exp.test(value))) {
                            this.toast(`${hintName}的格式不正确！`);
                            return false;
                        }
                    }
                }
                // group等需要再去检查子数据
                if (type === 'group' || type === 'condition-picker' || type === 'condition-select') {
                    if (required && this.$verify.isEmptyArray(children)) {
                        this.toast(`${hintName}数据不完整！`);
                        return false;
                    }
                    // 存在children
                    for (const child of children) {
                        if (!this.$verify.isEmptyArray(child) && child.length > 0) {
                            for (const childPro of child) {
                                if (!this.verifyData(childPro, hintName)) {
                                    return false;
                                }
                            }
                        } else {
                            return this.verifyData(child, hintName);
                        }
                    }
                }

                return true;
            },
            packDynamicData() {
                return this.dynamicData;
            },
            groupDataChange(groupData, children) {
                
                if(groupData.type==='selectGroup'){
                    this.stagingData=[]
                    let marriageData=JSON.parse(localStorage.getItem('marriageData'))
                    if(groupData.key==='litigants'){

                        children.forEach((value,index)=>{
                            let basicData=[] //基础数据值
                            let ptionData=[] //下拉选项值c
                            value.forEach((itemRes,indexRes)=>{
                                if(!itemRes.conditionValue){
                                    basicData.push(itemRes)
                                }else {
                                    if( marriageData[index]){
                                        marriageData[index].forEach(refValue=>{
                                            if(refValue.key===itemRes.key){
                                                if(itemRes.value){
                                                    refValue.value=itemRes.value
                                                }
                                            }
                                        })
                                    }
                                }

                            })
                             basicData= basicData.concat(marriageData[index])
                            this.stagingData.push(basicData)
                        })
                        groupData.children=this.stagingData
                        console.log(groupData.children,'最后合并的数据======<')
                    }
                }else {
                    groupData.children = children;
                }

                let obligor=[]
                
                if(groupData.key==='litigants'){
                    let newFillResults= groupData.children
                    newFillResults.forEach(item=>{
                        let  verifyInformation={}
                        item.forEach(ergodic=>{
                            if(ergodic.value){
                                verifyInformation[ergodic.key]=ergodic.value
                            }
                        })

                        obligor.push(verifyInformation)
                    })

                    localStorage.setItem('makeClear',JSON.stringify(obligor))

                }
                console.log("动态表单外层数据变化-groupChildren改变-",children,'|groupData=',groupData);
            },
            addTypeChangeData(groupData,children){
                groupData.children=children
            }
        }
    };
</script>

<style>
</style>
